<canvas
  #canvas
  id="{{id}}"
  class="pageCanvas"
  [style.--background-width]="background?.width ?? undefined"
  [style.--background-height]="background?.height ?? undefined"
  [style.--zoom-level]="zoomLevel"
  [class.canvasFullSize]="zoomLevel === 100"
  [class.active]="isActive()"
  (mouseover)="mouseover($event)"
  (mousedown)="mousedown($event)"
  (mousemove)="mousemove($event)"
  (mouseup)="mouseup($event)"
  (mouseleave)="mouseleave($event)"
  (touchstart)="touchdown($event)"
  (touchmove)="touchmove($event)"
  (touchend)="touchend($event)"
  touch-action="none"></canvas>
